// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610070935/js/" + chunkId + "." + {"44":"ce7367a6","225":"409b6d10","481":"ff016c8d","486":"da522930","770":"2d6e4160"}[chunkId] + ".0.4463966159659517.chunk.js";
};